import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { MuiThemeProvider, withTheme } from '@material-ui/core';
import { ContainerLayout } from 'data/components';
import { uiTheme, Toastr } from 'data/common';
import { initEnvironment, disconnectEnvironment } from '../actions';
import { setEnv } from '../data/Environments/actions';

class Layout extends PureComponent {
    static propTypes = {
        disconnectEnvironment: PropTypes.func.isRequired,
        initEnvironment: PropTypes.func.isRequired,
        children: PropTypes.object.isRequired,
        envBox: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            theme: uiTheme('testbench')
        };
    }

    componentDidMount() {
        const { profile, history } = this.props;
        if (!profile.get('admin') && !(profile.get('environments') && profile.get('environments').indexOf('testbench') !== -1)) {
            Toastr.error(Translator.translate('error.message.envForbidden'));
            return history.replace('/menu');
        }
        this.initEnv();
    }

    componentDidUpdate(prevProps) {
        const { envBox } = this.props;
        if (prevProps.envBox !== envBox) {
            this.changeTestBenchTheme(uiTheme(envBox));
        }
    }

    componentWillUnmount() {
        const { disconnectEnvironment } = this.props;
        disconnectEnvironment();
    }

    changeTestBenchTheme = otherTheme => {
        const { theme } = this.state;

        if (theme.id !== otherTheme.id) {
            this.setState({
                theme: otherTheme
            });
        }
    };

    initEnv = () => {
        const { initEnvironment } = this.props;
        this.setState({ loading: true, error: null });

        initEnvironment()
            .then(() => {
                this.setState({ loading: false, error: null });
            })
            .catch(err => {
                this.setState({
                    error: Translator.translateWithFallback(err.message, 'api.message.default'),
                    loading: false
                });
            });
    };

    render() {
        const { loading, error, theme } = this.state;
        const { children } = this.props;

        return (
            <MuiThemeProvider theme={theme}>
                <div className="d-flex flex-fill flex-column">
                    <ContainerLayout loading={loading} error={error} onClickFunc={this.initEnv}>
                        {children}
                    </ContainerLayout>
                </div>
            </MuiThemeProvider>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user,
        envBox: state.environments.testbench.data.Environments.get('active')
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ initEnvironment, disconnectEnvironment, setEnv }, dispatch)
    )(withTheme(Layout))
);



// WEBPACK FOOTER //
// ./environments/testbench/layouts/index.js